<!--
  - Copyright (c) Interactive Information R & D (I2RD) LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - I2RD LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with I2RD.
  -->

<template>
  <v-dialog v-model="openDialog" :key="dialogKey">
    <template v-slot:activator="{ on, attrs }">
      <blue-call-to-action
        class="float-right"
        @click="openDialog = true"
        v-bind="attrs"
        v-on="on"
      >
        <slot>
          <v-icon left>mdi-plus</v-icon>
          Connect New SignupID
        </slot>
      </blue-call-to-action>
    </template>
    <v-container id="connectSignupContainerId">
      <v-card id="connectSignupCardId">
        <v-btn icon absolute top right @click="dismiss">
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
        <connect-signup-i-d />
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
import BlueCallToAction from "@/components/providertrust/buttons/BlueCallToAction.vue";
import ConnectSignupID from "@/views/vendor/signup/ConnectSignupID.vue";

export default {
  name: "SignupCodeDialogButton",
  components: {
    ConnectSignupID,
    BlueCallToAction
  },
  data() {
    return {
      openDialog: false,
      dialogKey: 0
    };
  },
  methods: {
    dismiss() {
      this.openDialog = false;
      this.dialogKey++; //using a new key each display causes vue to not cache the component, and it's values to be fresh
    }
  }
};
</script>

<style>
/*flat isn't working on vcard*/
#connectSignupCardId .v-sheet.pt-sheet {
  border-radius: 0 !important;
  box-shadow: none !important;
}
#connectSignupContainerId {
  width: 600px;
}
#connectSignupCardId .col-sm-6.col-12 {
  max-width: 100% !important;
  flex: unset;
}
</style>
